import { Action } from '@ngrx/store';
import { ProblemModel } from './model';

export enum ActionTypes {
  FAILURE = '[Problem] Failure',

  LOAD_REQUEST = '[Problem] Load Request',
  LOAD_SUCCESS = '[Problem] Load Success',

  SAVE_REQUEST = '[Problem] Save Request',
  SAVE_SUCCESS = '[Problem] Save Success',

  CREATE_REQUEST = '[Problem] Create Request',
  CREATE_SUCCESS = '[Problem] Create Success',

  DELETE_REQUEST = '[Problem] Delete Request',
  DELETE_SUCCESS = '[Problem] Delete Success',

  SET_SELECTED_REQUEST = '[Problem] Set Selected Request',
  SET_SELECTED_SUCCESS = '[Problem] Set Selected Success',

  SOLVED_REQUEST = '[Problem] Solved Request',
  SOLVED_SUCCESS = '[Problem] Solved Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}
export class LoadRequestAction implements Action {
  readonly type = ActionTypes.LOAD_REQUEST;
}

export class LoadSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_SUCCESS;
  constructor(public items: ProblemModel[]) {}
}

export class SaveRequestAction implements Action {
  readonly type = ActionTypes.SAVE_REQUEST;

  constructor(public problem: ProblemModel) {}
}

export class SaveSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_SUCCESS;

  constructor(public item: ProblemModel) {}
}

export class CreateRequestAction implements Action {
  readonly type = ActionTypes.CREATE_REQUEST;

  constructor(public problem: ProblemModel) {}
}

export class CreateSuccessAction implements Action {
  readonly type = ActionTypes.CREATE_SUCCESS;

  constructor(public problem: ProblemModel) {}
}

export class DeleteRequestAction implements Action {
  readonly type = ActionTypes.DELETE_REQUEST;

  constructor(public id: number) {}
}

export class DeleteSuccessAction implements Action {
  readonly type = ActionTypes.DELETE_SUCCESS;

  constructor(public id: number) {}
}

export class SetSelectedRequestAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_REQUEST;

  constructor(public id: number) {}
}

export class SetSelectedSuccessAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_SUCCESS;

  constructor(public problem: ProblemModel) {}
}

export class SolvedRequestAction implements Action {
  readonly type = ActionTypes.SOLVED_REQUEST;

  constructor(public id: number) {}
}

export class SolvedSuccessAction implements Action {
  readonly type = ActionTypes.SOLVED_SUCCESS;

  constructor(public problem: ProblemModel) {}
}

export type Actions =
  | FailureAction
  | LoadRequestAction
  | LoadSuccessAction
  | SaveRequestAction
  | SaveSuccessAction
  | CreateRequestAction
  | CreateSuccessAction
  | DeleteRequestAction
  | DeleteSuccessAction
  | SetSelectedRequestAction
  | SetSelectedSuccessAction
  | SolvedRequestAction
  | SolvedSuccessAction;
